import Link from "next/link";
import Image from "next/image";
import React from "react";
import { dateFormatter } from "@services/utils";

type PostProps = {
  titre: string;
  description?: string;
  date?: string;
  pic?: string;
  slug: string;
};

const Article: React.FC<PostProps> = ({ titre, description, date, pic, slug }) => {
  return (
    <Link href={`/article/${slug}`} passHref>
      <a id="article-slide" className="embla__slide">
        <div id="article-container" className="card group flex h-full flex-col gap-x-0 gap-y-4 overflow-hidden border-opacity-60 !bg-blackAccent lg:flex-row lg:gap-x-16 lg:gap-y-0">
          {/* image */}
          {pic && (
            <div id="article-image" className="relative aspect-video h-full w-full overflow-hidden rounded lg:w-2/5">
              <Image quality={100} layout="fill" src={`https:${pic}?fm=webp&q=95`} alt={`Photo de ${titre}`} title={`Photo de ${titre}`} objectFit="cover" className="transform rounded object-cover object-center transition duration-300 group-hover:scale-105" placeholder="blur" blurDataURL={`https:${pic}?fm=webp&q=30`} />
            </div>
            // <div id="article-image" className="relative aspect-video w-full flex-1 lg:w-1/2">
            //   <Image quality={100} layout="fill" src={`https:${pic}?fm=webp&q=100`} alt={`Photo de ${titre}`} title={`Photo de ${titre}`} objectFit="cover" className="transform rounded object-center" placeholder="blur" blurDataURL={`https:${pic}?fm=webp&q=40`} />
            // </div>
          )}

          {/* content */}
          <div id="article-content-container" className="flex h-full w-full flex-col justify-center overflow-hidden lg:w-3/5">
            {/* tags and date */}
            <p id="article-content-date" className="w-fit text-left text-sm font-medium text-redAccent opacity-70 md:tracking-widest">
              {dateFormatter(date)}
            </p>
            {/* title */}
            <h3 id="article-content-titre" className="my-2 overflow-hidden text-ellipsis text-left font-bold line-clamp-2 group-hover:underline">
              {titre}
            </h3>
            <p id="article-content-description" className="text-left text-whiteAccent/50 line-clamp-2">
              {description && description}
            </p>
          </div>
        </div>
      </a>
    </Link>
  );
};

export default Article;
